// Fragment "platform automation codes and action settings, S8 round 3" — merged into ./index.js.
// Convention: flat dotted keys, values in the 3 languages, never empty.
// Backs super_admin/automation/automationCodes.js (one word per trigger code and action type,
// hauto.trigger.* / hauto.action.*; the five action names stay in base.js), ActionConfigForm.jsx
// (the per-action settings the server requires, hq-customers-contract.md 4.3), the rule forms
// (CustomRulesPanel.jsx, VisualWorkflowEditor.jsx) and the dry run's 409.
// `hauto.cfg.rule.<field>` states the server's rule for the field; it is what the form shows
// when the field is refused, by the form itself or by a 400 invalid_action_config.
export default {
  fr: {
    "hauto.trigger.invoice.overdue": "Facture en retard",
    "hauto.trigger.lead.created": "Nouveau prospect",
    "hauto.trigger.nps.low": "Score NPS bas",
    "hauto.trigger.schedule.daily": "Chaque jour",
    "hauto.trigger.service.interest": "Intérêt pour une offre Solunary Services",
    "hauto.trigger.tenant.churn": "Cabinet perdu",
    "hauto.trigger.tenant.signup": "Inscription d'un cabinet",
    "hauto.trigger.tenant.trial_converted": "Essai converti en abonnement",
    "hauto.trigger.tenant.trial_ending": "Fin d'essai proche",
    "hauto.trigger.unknown": "Déclencheur inconnu",
    "hauto.action.invalid": "Action illisible",
    "hauto.action.unknown": "Action inconnue",
    "hauto.cfg.title": "Réglages de l'action",
    "hauto.cfg.field.stage": "Étape",
    "hauto.cfg.field.tag": "Étiquette",
    "hauto.cfg.field.title": "Titre de la tâche",
    "hauto.cfg.field.description": "Description",
    "hauto.cfg.field.assignee": "Assignée à",
    "hauto.cfg.field.subject": "Objet",
    "hauto.cfg.field.body": "Message (HTML)",
    "hauto.cfg.field.to": "Destinataire",
    "hauto.cfg.optionalLabel": "{label} (facultatif)",
    "hauto.cfg.field.channel": "Canal Slack",
    "hauto.cfg.rule.stage": "Choisissez une étape.",
    "hauto.cfg.rule.tag": "Saisissez une étiquette de 1 à {max} caractères, sans caractère de contrôle.",
    "hauto.cfg.rule.title": "Saisissez un titre visible sur une ligne, de {max} caractères au plus.",
    "hauto.cfg.rule.description": "La description fait au plus {max} caractères, sans caractère de contrôle autre que les retours à la ligne et tabulations.",
    "hauto.cfg.rule.assignee": "Une seule ligne, de {max} caractères au plus.",
    "hauto.cfg.rule.subject": "Saisissez un objet visible sur une ligne, de {max} caractères au plus.",
    "hauto.cfg.rule.body": "Saisissez un message avec du texte visible, de {max} caractères au plus, sans caractère de contrôle.",
    "hauto.cfg.required.stage": "Choisissez une étape.",
    "hauto.cfg.required.tag": "Saisissez une étiquette.",
    "hauto.cfg.required.title": "Saisissez un titre de tâche.",
    "hauto.cfg.required.subject": "Saisissez un objet.",
    "hauto.cfg.required.body": "Saisissez un message.",
    "hauto.cfg.required.channel": "Saisissez un canal Slack, par exemple #alertes-churn.",
    "hauto.cfg.tooLong": "Trop long : {count} caractères, {max} au plus.",
    "hauto.cfg.tooLong.channel": "Trop long : {count} caractères après le #, {max} au plus.",
    "hauto.issue.field": "« {field} » manque ou n'est pas valide.",
    "hauto.issue.config": "Ses réglages sont illisibles.",
    "hauto.issue.type": "Son type n'est pas une action connue.",
    "hauto.issue.action": "Elle est illisible.",
    "hauto.issue.other": "Ses réglages ne sont pas valides.",
    "hauto.setup.badge": "À configurer",
    "hauto.setup.hint": "Ces actions sont ignorées à chaque exécution tant qu'elles ne sont pas configurées :",
    "hauto.setup.item": "Action {n} ({action}) : {problem}",
    "hauto.setup.open": "Configurer",
    "hauto.err.nameRequired": "Saisissez un nom de règle.",
    "hauto.err.ruleName": "Le nom d'une règle tient sur une ligne, avec du texte visible, en {max} caractères au plus.",
    "hauto.dryRun.practiceNeedsSuperAdmin": "La simulation sur un cabinet est réservée à un super admin : cette simulation se fait sans cabinet.",
    "hauto.cfg.rule.to": "Saisissez une adresse e-mail valide, ou laissez vide.",
    "hauto.cfg.rule.channel": "Un canal commence par # suivi de 1 à {max} caractères, sans espace.",
    "hauto.cfg.rule.config": "Les réglages de cette action sont illisibles : retirez-la.",
    "hauto.cfg.ph.to": "Par défaut : l'adresse de l'événement",
    "hauto.cfg.ph.channel": "#alertes-churn",
    "hauto.cfg.bodyHint": "Envoyé tel quel, en HTML.",
    "hauto.cfg.pickAction": "Choisissez au moins une action.",
    "hauto.cfg.fixFields": "Complétez les réglages signalés avant d'enregistrer.",
    "hauto.err.invalidActionConfig.field": "Action {n} ({action}) : {rule}",
    "hauto.err.ruleTriggerUnsupported": "Le déclencheur de cette règle n'existe plus : elle ne peut pas être testée. Choisissez un autre déclencheur.",
    "vwe.actionSettingsHint": "Cliquez sur une action pour modifier ses réglages.",
    "vwe.removeAction": "Retirer l'action",
    "vwe.unreadableAction": "Cette action est illisible. Retirez-la pour enregistrer les actions.",
  },
  en: {
    "hauto.trigger.invoice.overdue": "Invoice overdue",
    "hauto.trigger.lead.created": "New lead",
    "hauto.trigger.nps.low": "Low NPS score",
    "hauto.trigger.schedule.daily": "Every day",
    "hauto.trigger.service.interest": "Interest in a Services offer",
    "hauto.trigger.tenant.churn": "Practice churned",
    "hauto.trigger.tenant.signup": "Practice signed up",
    "hauto.trigger.tenant.trial_converted": "Trial converted to a subscription",
    "hauto.trigger.tenant.trial_ending": "Trial ending soon",
    "hauto.trigger.unknown": "Unknown trigger",
    "hauto.action.invalid": "Unreadable action",
    "hauto.action.unknown": "Unknown action",
    "hauto.cfg.title": "Action settings",
    "hauto.cfg.field.stage": "Stage",
    "hauto.cfg.field.tag": "Tag",
    "hauto.cfg.field.title": "Task title",
    "hauto.cfg.field.description": "Description",
    "hauto.cfg.field.assignee": "Assignee",
    "hauto.cfg.field.subject": "Subject",
    "hauto.cfg.field.body": "Message (HTML)",
    "hauto.cfg.field.to": "Recipient",
    "hauto.cfg.optionalLabel": "{label} (optional)",
    "hauto.cfg.field.channel": "Slack channel",
    "hauto.cfg.rule.stage": "Choose a stage.",
    "hauto.cfg.rule.tag": "Enter a tag of 1 to {max} characters, with no control characters.",
    "hauto.cfg.rule.title": "Enter a visible title on one line, at most {max} characters.",
    "hauto.cfg.rule.description": "The description is at most {max} characters, with no control characters other than line breaks and tabs.",
    "hauto.cfg.rule.assignee": "One line, at most {max} characters.",
    "hauto.cfg.rule.subject": "Enter a visible subject on one line, at most {max} characters.",
    "hauto.cfg.rule.body": "Enter a message with visible text, at most {max} characters, without control characters.",
    "hauto.cfg.required.stage": "Choose a stage.",
    "hauto.cfg.required.tag": "Enter a tag.",
    "hauto.cfg.required.title": "Enter a task title.",
    "hauto.cfg.required.subject": "Enter a subject.",
    "hauto.cfg.required.body": "Enter a message.",
    "hauto.cfg.required.channel": "Enter a Slack channel, such as #churn-alerts.",
    "hauto.cfg.tooLong": "Too long: {count} characters, at most {max}.",
    "hauto.cfg.tooLong.channel": "Too long: {count} characters after the #, at most {max}.",
    "hauto.issue.field": "“{field}” is missing or not valid.",
    "hauto.issue.config": "Its settings cannot be read.",
    "hauto.issue.type": "Its type is not a known action.",
    "hauto.issue.action": "It cannot be read.",
    "hauto.issue.other": "Its settings are not valid.",
    "hauto.setup.badge": "Needs setup",
    "hauto.setup.hint": "These actions are skipped at every run until they are set up:",
    "hauto.setup.item": "Action {n} ({action}): {problem}",
    "hauto.setup.open": "Set up",
    "hauto.err.nameRequired": "Enter a rule name.",
    "hauto.err.ruleName": "A rule name is one line of visible text, at most {max} characters.",
    "hauto.dryRun.practiceNeedsSuperAdmin": "Simulating against a practice needs a super admin, so this run uses no practice.",
    "hauto.cfg.rule.to": "Enter a valid email address, or leave it empty.",
    "hauto.cfg.rule.channel": "A channel is # followed by 1 to {max} characters, with no spaces.",
    "hauto.cfg.rule.config": "This action's settings cannot be read: remove it.",
    "hauto.cfg.ph.to": "Default: the event's email address",
    "hauto.cfg.ph.channel": "#churn-alerts",
    "hauto.cfg.bodyHint": "Sent exactly as written, as HTML.",
    "hauto.cfg.pickAction": "Choose at least one action.",
    "hauto.cfg.fixFields": "Complete the highlighted settings before saving.",
    "hauto.err.invalidActionConfig.field": "Action {n} ({action}): {rule}",
    "hauto.err.ruleTriggerUnsupported": "This rule's trigger no longer exists, so it cannot be tested. Choose another trigger.",
    "vwe.actionSettingsHint": "Click an action to edit its settings.",
    "vwe.removeAction": "Remove action",
    "vwe.unreadableAction": "This action cannot be read. Remove it to save the actions.",
  },
  es: {
    "hauto.trigger.invoice.overdue": "Factura vencida",
    "hauto.trigger.lead.created": "Nuevo cliente potencial",
    "hauto.trigger.nps.low": "Puntuación NPS baja",
    "hauto.trigger.schedule.daily": "Cada día",
    "hauto.trigger.service.interest": "Interés en una oferta de Solunary Services",
    "hauto.trigger.tenant.churn": "Consulta perdida",
    "hauto.trigger.tenant.signup": "Alta de una consulta",
    "hauto.trigger.tenant.trial_converted": "Prueba convertida en suscripción",
    "hauto.trigger.tenant.trial_ending": "La prueba termina pronto",
    "hauto.trigger.unknown": "Disparador desconocido",
    "hauto.action.invalid": "Acción ilegible",
    "hauto.action.unknown": "Acción desconocida",
    "hauto.cfg.title": "Configuración de la acción",
    "hauto.cfg.field.stage": "Etapa",
    "hauto.cfg.field.tag": "Etiqueta",
    "hauto.cfg.field.title": "Título de la tarea",
    "hauto.cfg.field.description": "Descripción",
    "hauto.cfg.field.assignee": "Asignada a",
    "hauto.cfg.field.subject": "Asunto",
    "hauto.cfg.field.body": "Mensaje (HTML)",
    "hauto.cfg.field.to": "Destinatario",
    "hauto.cfg.optionalLabel": "{label} (opcional)",
    "hauto.cfg.field.channel": "Canal de Slack",
    "hauto.cfg.rule.stage": "Elige una etapa.",
    "hauto.cfg.rule.tag": "Escribe una etiqueta de 1 a {max} caracteres, sin caracteres de control.",
    "hauto.cfg.rule.title": "Escribe un título visible en una línea, de {max} caracteres como máximo.",
    "hauto.cfg.rule.description": "La descripción tiene {max} caracteres como máximo, sin caracteres de control salvo saltos de línea y tabulaciones.",
    "hauto.cfg.rule.assignee": "Una sola línea, de {max} caracteres como máximo.",
    "hauto.cfg.rule.subject": "Escribe un asunto visible en una línea, de {max} caracteres como máximo.",
    "hauto.cfg.rule.body": "Escribe un mensaje con texto visible, de {max} caracteres como máximo, sin caracteres de control.",
    "hauto.cfg.required.stage": "Elige una etapa.",
    "hauto.cfg.required.tag": "Escribe una etiqueta.",
    "hauto.cfg.required.title": "Escribe un título para la tarea.",
    "hauto.cfg.required.subject": "Escribe un asunto.",
    "hauto.cfg.required.body": "Escribe un mensaje.",
    "hauto.cfg.required.channel": "Escribe un canal de Slack, por ejemplo #alertas-churn.",
    "hauto.cfg.tooLong": "Demasiado largo: {count} caracteres, {max} como máximo.",
    "hauto.cfg.tooLong.channel": "Demasiado largo: {count} caracteres después del #, {max} como máximo.",
    "hauto.issue.field": "«{field}» falta o no es válido.",
    "hauto.issue.config": "Su configuración no se puede leer.",
    "hauto.issue.type": "Su tipo no es una acción conocida.",
    "hauto.issue.action": "No se puede leer.",
    "hauto.issue.other": "Su configuración no es válida.",
    "hauto.setup.badge": "Por configurar",
    "hauto.setup.hint": "Estas acciones se omiten en cada ejecución hasta que se configuren:",
    "hauto.setup.item": "Acción {n} ({action}): {problem}",
    "hauto.setup.open": "Configurar",
    "hauto.err.nameRequired": "Escribe un nombre para la regla.",
    "hauto.err.ruleName": "El nombre de una regla es una sola línea de texto visible, de {max} caracteres como máximo.",
    "hauto.dryRun.practiceNeedsSuperAdmin": "La simulación con una consulta requiere un superadministrador, así que esta simulación se hace sin consulta.",
    "hauto.cfg.rule.to": "Escribe una dirección de correo válida, o déjalo vacío.",
    "hauto.cfg.rule.channel": "Un canal es # seguido de 1 a {max} caracteres, sin espacios.",
    "hauto.cfg.rule.config": "No se puede leer la configuración de esta acción: quítala.",
    "hauto.cfg.ph.to": "Por defecto: el correo del evento",
    "hauto.cfg.ph.channel": "#alertas-churn",
    "hauto.cfg.bodyHint": "Se envía tal cual, en HTML.",
    "hauto.cfg.pickAction": "Elige al menos una acción.",
    "hauto.cfg.fixFields": "Completa la configuración señalada antes de guardar.",
    "hauto.err.invalidActionConfig.field": "Acción {n} ({action}): {rule}",
    "hauto.err.ruleTriggerUnsupported": "El disparador de esta regla ya no existe, así que no se puede probar. Elige otro disparador.",
    "vwe.actionSettingsHint": "Haz clic en una acción para editar su configuración.",
    "vwe.removeAction": "Quitar la acción",
    "vwe.unreadableAction": "Esta acción no se puede leer. Quítala para guardar las acciones.",
  },
};
